import { ActionIcon, Box, Menu } from '@mantine/core';
import DeleteAutomationModal from '@/pages/Automations/components/DeleteAutomationModal.tsx';
import { HiEllipsisHorizontal } from 'react-icons/hi2';
import EditAutomationModal from '@/pages/Automations/components/EditAutomationModal.tsx';
import { useState } from 'react';
import StyledMenu from '@/components/StyledMenu/StyledMenu.tsx';
import { Automation } from '@/types/automations.ts';
import AutomationMetadataModal from '@/pages/Automations/components/AutomationMetadataModal.tsx';

type AutomationMenuProps = {
  automation: Automation;
};

const AutomationMenu = ({ automation }: AutomationMenuProps) => {
  const [deleteAutomation, setDeleteAutomation] = useState<Automation | null>(null);
  const [editAutomation, setEditAutomation] = useState<Automation | null>(null);
  const [metadataAutomation, setMetadataAutomation] = useState<Automation | null>(null);

  return (
    <Box
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
      style={{ marginRight: '-12px' }}
    >
      <StyledMenu position="bottom-end">
        <Menu.Target>
          <ActionIcon variant={'subtle'} color="#757575">
            <HiEllipsisHorizontal size="1.5em" />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown
          styles={{
            dropdown: {
              width: '10%',
              height: 'auto',
            },
          }}
        >
          <Menu.Item onClick={() => setEditAutomation(automation)}>Rename</Menu.Item>
          <Menu.Item onClick={() => setMetadataAutomation(automation)}>Metadata</Menu.Item>
          <Menu.Item c="red" onClick={() => setDeleteAutomation(automation)}>
            Delete
          </Menu.Item>
        </Menu.Dropdown>
      </StyledMenu>
      {editAutomation && (
        <EditAutomationModal automation={editAutomation} onClose={() => setEditAutomation(null)} />
      )}
      {deleteAutomation && (
        <DeleteAutomationModal
          automation={deleteAutomation}
          onClose={() => setDeleteAutomation(null)}
        />
      )}
      {metadataAutomation && (
        <AutomationMetadataModal
          automation={metadataAutomation}
          opened={true}
          onClose={() => setMetadataAutomation(null)}
        />
      )}
    </Box>
  );
};

export default AutomationMenu;
